/* eslint-disable no-dupe-keys */
import React, { useState } from 'react'
import { Box, Typography, Button, Tooltip, TextField, InputAdornment, FormControl, Select, MenuItem } from '@mui/material'
import RadioBoxGroup from '../../../components/RadioButtons/RadioBoxGroup'
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import SearchIcon from '@mui/icons-material/Search';
import ProjectTable from './ProjectTable'
import TimerIndividualTable from './TimerIndividualTable'
import AutomaticTimer from '../../../components/Projects/AutomaticTimer';


const roles = [
    { label: 'Never', },
    { label: '5 Mins', },
    { label: '10 Mins', },
    { label: '20 mins', },
    { label: 'Custom', },

];

const TimerTracking = () => {
    const [openAutomaticTimer, setOpenAutomaticTimer] = useState(false);

    const [role, setRole] = useState('');
    const handleChangeUser = (event) => {
        setRole(event.target.value);
    };

    const [activeTab, setActiveTab] = useState('allowed');

    return (
        <>
            <Box sx={{
                overflowX: { xs: 'auto', sm: 'auto', md: 'visible' },
                maxWidth: '100%',
            }}>
                {/* Tabs */}
                <Box display="inline-flex"
                    gap={1}
                    mb={0}
                    sx={{
                        flexWrap: 'nowrap',
                        minWidth: 'max-content',
                    }}>
                    <Button onClick={() => setActiveTab('allowed')} variant="contained" sx={{
                        fontFamily: 'Manrope',
                        height: '38px', borderRadius: '100px', backgroundColor: '#fff',
                        backgroundColor: activeTab === 'allowed' ? '#0076FE' : '#fff', color: activeTab === 'allowed' ? '#fff' : '#64748B', border: activeTab === 'allowed' ? '1px solid #0076FE' : '1px solid #D0D5DD',
                        fontWeight: 600, fontSize: { xl: '14px', lg: '12px', md: '12px', sm: '12px', xs: '14px' },
                        padding: { xl: '8px 16px', lg: '8px 12px', md: '8px 12px', sm: '8px 12px', xs: '8px 16px' }, boxShadow: 'none', '&:hover': { backgroundColor: '#0076FE', border: '1px solid #0076FE', color: '#fff', },
                    }} >
                        Allowed apps</Button>
                    <Button onClick={() => setActiveTab('idleTab')} variant="contained" sx={{
                        fontFamily: 'Manrope',
                        height: '38px', borderRadius: '100px', backgroundColor: '#fff', backgroundColor: activeTab === 'idleTab' ? '#0076FE' : '#fff',
                        color: activeTab === 'idleTab' ? '#fff' : '#64748B', border: activeTab === 'idleTab' ? '1px solid #0076FE' : '1px solid #D0D5DD', fontWeight: 600, fontSize: { xl: '14px', lg: '12px', md: '12px', sm: '12px', xs: '14px' },
                        padding: { xl: '8px 16px', lg: '8px 12px', md: '8px 12px', sm: '8px 12px', xs: '8px 16px' },
                        boxShadow: 'none', '&:hover': { backgroundColor: '#0076FE', border: '1px solid #0076FE', color: '#fff', },
                    }}>Idle timeout
                    </Button>

                    <Button onClick={() => setActiveTab('keepTab')} variant="contained" sx={{
                        fontFamily: 'Manrope',
                        height: '38px', borderRadius: '100px', backgroundColor: '#fff', backgroundColor: activeTab === 'keepTab' ? '#0076FE' : '#fff',
                        color: activeTab === 'keepTab' ? '#fff' : '#64748B', border: activeTab === 'keepTab' ? '1px solid #0076FE' : '1px solid #D0D5DD', fontWeight: 600, fontSize: { xl: '14px', lg: '12px', md: '12px', sm: '12px', xs: '14px' },
                        padding: { xl: '8px 16px', lg: '8px 12px', md: '8px 12px', sm: '8px 12px', xs: '8px 16px' },
                        boxShadow: 'none', '&:hover': { backgroundColor: '#0076FE', border: '1px solid #0076FE', color: '#fff', },
                    }}>Keep idle time
                    </Button>

                    <Button onClick={() => setActiveTab('automaticTab')} variant="contained" sx={{
                        fontFamily: 'Manrope',
                        height: '38px', borderRadius: '100px', backgroundColor: '#fff', backgroundColor: activeTab === 'automaticTab' ? '#0076FE' : '#fff',
                        color: activeTab === 'automaticTab' ? '#fff' : '#64748B', border: activeTab === 'automaticTab' ? '1px solid #0076FE' : '1px solid #D0D5DD', fontWeight: 600, fontSize: { xl: '14px', lg: '12px', md: '12px', sm: '12px', xs: '14px' },
                        padding: { xl: '8px 16px', lg: '8px 12px', md: '8px 12px', sm: '8px 12px', xs: '8px 16px' },
                        boxShadow: 'none', '&:hover': { backgroundColor: '#0076FE', border: '1px solid #0076FE', color: '#fff', },
                    }}>Automatic tracking policy
                    </Button>
                </Box>
                {/* Tab Panel Content */}
            </Box>

            <Box sx={{ '& MuiBox-root': { padding: '0' } }}>
                <CustomTabPanel sx={{ '& MuiBox-root': { padding: '0' } }} value={activeTab} index="allowed">
                    <Box>
                        <Typography display="flex" alignItems="center" sx={{ m: '0 auto 4px', gap: '12px', fontSize: '16px', color: '#9095A1', fontWeight: '600', fontFamily: 'Manrope', textTransform: 'uppercase', lineHeight: '1' }}>
                            Allowed apps
                            <Tooltip title="This setting applies to all timer apps." arrow placement="top" alignContent="center">
                                <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                                    <InfoOutlineIcon fontSize="small" />
                                </button>
                            </Tooltip>
                        </Typography>
                        <Typography sx={{ fontSize: '12px', color: '#1A1F36', fontWeight: '400', fontFamily: 'Manrope' }}>Manage the timer applications that team members are permitted to use.</Typography>
                    </Box>
                    <Box sx={{ m: '32px auto 24px', paddingBottom: '24px', borderBottom: '1px solid #D0D4E4', display: 'flex', justifyContent: 'space-between', alignItems: 'center', }}>
                        <Typography display="flex" alignItems="center" sx={{ gap: '12px', fontSize: { xl: '20px', lg: '16px', md: '16px', sm: '16px', xs: '14px' }, color: '#1A1F36', fontWeight: '600', fontFamily: 'Manrope', lineHeight: '1' }}>
                            Global Setting
                            <Tooltip title="Organization default: Applied to all members automatically." arrow placement="top" alignContent="center">
                                <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                                    <InfoOutlineIcon fontSize="small" />
                                </button>
                            </Tooltip>

                        </Typography>
                        <RadioBoxGroup
                            options={['All Apps', 'Desktop Only', 'Mobile Only',]}
                            defaultValue="All Apps"
                            row={true}
                        />
                    </Box>
                    <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ marginBottom: '20px', flexWrap: { xl: 'nowrap', lg: 'nowrap', md: 'nowrap', sm: 'wrap', sx: 'wrap' } }}>
                        <Box sx={{ marginBottom: '10px' }}>
                            <Typography sx={{ fontSize: { xl: '20px', lg: '16px', md: '16px', sm: '16px', xs: '14px' }, fontWeight: '600', color: '#1E1E1E', fontFamily: 'Manrope' }}>Individual settings</Typography>
                            <Typography sx={{ fontSize: '12px', fontWeight: '400', color: '#9095A1', fontFamily: 'Manrope' }}>Customize settings for individual members instead of using the organization default.</Typography>
                        </Box>
                        <TextField sx={{ width: { xl: 'auto', lg: 'auto', md: 'auto', sm: '100%', xs: '100%' } }}
                            placeholder="Search Member"
                            size="small"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                                sx: { marginBottom: '10px', width: '100%', borderRadius: '20px', background: '#fff', fontSize: '13px', minWidth: { xl: '250px', lg: '250px', md: '180px', sm: '180px', xs: '160px' }, fontFamily: 'Manrope' },
                            }}
                        />
                    </Box>
                    <ProjectTable />
                </CustomTabPanel>
                <CustomTabPanel sx={{ '& MuiBox-root': { padding: '0' } }} value={activeTab} index="idleTab">
                    <Box>
                        <Typography display="flex" alignItems="center" sx={{ m: '0 auto 4px', gap: '12px', fontSize: '16px', color: '#9095A1', fontWeight: '600', fontFamily: 'Manrope', textTransform: 'uppercase', lineHeight: '1' }}>
                            Idle timeout
                            <Tooltip title="This setting applies to desktop apps." arrow placement="top" alignContent="center">
                                <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                                    <InfoOutlineIcon fontSize="small" />
                                </button>
                            </Tooltip>
                        </Typography>
                        <Typography sx={{ fontSize: '12px', color: '#1A1F36', fontWeight: '400', fontFamily: 'Manrope' }}>Manage the settings for how the desktop application identifies periods of inactivity.</Typography>
                    </Box>
                    <Box sx={{ m: '32px auto 24px', paddingBottom: '24px', borderBottom: '1px solid #D0D4E4', display: 'flex', justifyContent: 'space-between', alignItems: 'center', }}>
                        <Typography display="flex" alignItems="center" sx={{ gap: '12px', fontSize: { xl: '20px', lg: '16px', md: '16px', sm: '16px', xs: '14px' }, color: '#1A1F36', fontWeight: '600', fontFamily: 'Manrope', lineHeight: '1' }}>
                            Global Setting
                            <Tooltip title="Organization default: All current and future members will automatically receive this setting." arrow placement="top" alignContent="center">
                                <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                                    <InfoOutlineIcon fontSize="small" />
                                </button>
                            </Tooltip>
                        </Typography>
                        <Box display="flex" alignItems="center" sx={{ gap: '12px' }}>
                            <Box sx={{ width: 200 }}>
                                <FormControl fullWidth variant="outlined" size="small">
                                    <Select value={role} onChange={handleChangeUser} displayEmpty renderValue={(selected) => selected ? (selected) : (
                                        <Typography color="text.secondary" sx={{ fontSize: '14px', color: '#64748B', fontWeight: '400', fontFamily: 'Manrope', }}>
                                            Never
                                        </Typography>
                                    )}
                                        sx={{ backgroundColor: 'white', fontFamily: 'Manrope', fontSize: '14px', color: '#64748B', borderRadius: '100px' }}>
                                        {roles.map((option) => (
                                            <MenuItem key={option.label} value={option.label}>
                                                <Box>
                                                    <Typography variant="body1" sx={{ fontSize: '14px', color: '#1A1F36', fontWeight: '500', fontFamily: 'Manrope' }}>{option.label}</Typography>
                                                </Box>
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Box>
                            <Button variant="contained" sx={{ boxShadow: 'none', fontFamily: 'Manrope', height: '38px', borderRadius: '100px', backgroundColor: '#0076FE', border: '1px solid #0076FE', color: '#fff', textTransform: 'capitalize' }} >
                                Apply to all</Button>
                        </Box>
                    </Box>
                    <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ marginBottom: '20px', flexWrap: { xl: 'nowrap', lg: 'nowrap', md: 'nowrap', sm: 'wrap', sx: 'wrap' } }}>
                        <Box sx={{ marginBottom: '10px' }}>
                            <Typography sx={{ fontSize: { xl: '20px', lg: '16px', md: '16px', sm: '16px', xs: '14px' }, fontWeight: '600', color: '#1E1E1E', fontFamily: 'Manrope' }}>Individual settings</Typography>
                            <Typography sx={{ fontSize: '12px', fontWeight: '400', color: '#9095A1', fontFamily: 'Manrope' }}>Customize settings for individual members instead of using the organization default.</Typography>
                        </Box>
                        <TextField sx={{ width: { xl: 'auto', lg: 'auto', md: 'auto', sm: '100%', xs: '100%' } }}
                            placeholder="Search Member"
                            size="small"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                                sx: { marginBottom: '10px', width: '100%', borderRadius: '20px', background: '#fff', fontSize: '13px', minWidth: { xl: '250px', lg: '250px', md: '180px', sm: '180px', xs: '160px' }, fontFamily: 'Manrope' },
                            }}
                        />
                    </Box>
                    <TimerIndividualTable />
                </CustomTabPanel>
                <CustomTabPanel sx={{ '& MuiBox-root': { padding: '0' } }} value={activeTab} index="keepTab">
                    <Box>
                        <Typography display="flex" alignItems="center" sx={{ m: '0 auto 4px', gap: '12px', fontSize: '16px', color: '#9095A1', fontWeight: '600', fontFamily: 'Manrope', textTransform: 'uppercase', lineHeight: '1' }}>
                            Keep idle time
                            <Tooltip title="This setting applies to all timer apps." arrow placement="top" alignContent="center">
                                <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                                    <InfoOutlineIcon fontSize="small" />
                                </button>
                            </Tooltip>
                        </Typography>
                        <Typography sx={{ fontSize: '12px', color: '#1A1F36', fontWeight: '400', fontFamily: 'Manrope' }}>Manage the idle time settings for the desktop application.</Typography>
                    </Box>
                    <Box sx={{ m: '32px auto 24px', paddingBottom: '24px', borderBottom: '1px solid #D0D4E4', display: 'flex', justifyContent: 'space-between', alignItems: 'center', }}>
                        <Typography display="flex" alignItems="center" sx={{ gap: '12px', fontSize: { xl: '20px', lg: '16px', md: '16px', sm: '16px', xs: '14px' }, color: '#1A1F36', fontWeight: '600', fontFamily: 'Manrope', lineHeight: '1' }}>
                            Global Setting
                            <Tooltip title="Organization default: Applies to all members by default." arrow placement="top" alignContent="center">
                                <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                                    <InfoOutlineIcon fontSize="small" />
                                </button>
                            </Tooltip>

                        </Typography>
                        <RadioBoxGroup
                            options={['Prompt', 'Always', 'Never']}
                            defaultValue="Prompt"
                            row={true}
                        />
                    </Box>
                    <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ marginBottom: '20px', flexWrap: { xl: 'nowrap', lg: 'nowrap', md: 'nowrap', sm: 'wrap', sx: 'wrap' } }}>
                        <Box sx={{ marginBottom: '10px' }}>
                            <Typography sx={{ fontSize: { xl: '20px', lg: '16px', md: '16px', sm: '16px', xs: '14px' }, fontWeight: '600', color: '#1E1E1E', fontFamily: 'Manrope' }}>Individual settings</Typography>
                            <Typography sx={{ fontSize: '12px', fontWeight: '400', color: '#9095A1', fontFamily: 'Manrope' }}>Customize settings for individual members instead of using the organization default.</Typography>
                        </Box>
                        <TextField sx={{ width: { xl: 'auto', lg: 'auto', md: 'auto', sm: '100%', xs: '100%' } }}
                            placeholder="Search Member"
                            size="small"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                                sx: { marginBottom: '10px', width: '100%', borderRadius: '20px', background: '#fff', fontSize: '13px', minWidth: { xl: '250px', lg: '250px', md: '180px', sm: '180px', xs: '160px' }, fontFamily: 'Manrope' },
                            }}
                        />
                    </Box>
                    <ProjectTable />
                </CustomTabPanel>
                <CustomTabPanel sx={{ '& MuiBox-root': { padding: '0' } }} value={activeTab} index="automaticTab">
                   <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ marginBottom: '20px', flexWrap: { xl: 'nowrap', lg: 'nowrap', md: 'wrap', sm: 'wrap', xs: 'wrap' } }}>
                     <Box sx={{ marginBottom: '10px' }}>
                            <Typography sx={{ fontSize: { xl: '20px', lg: '16px', md: '16px', sm: '16px', xs: '14px' }, fontWeight: '600', color: '#1E1E1E', fontFamily: 'Manrope' }}>Automatic tracking policy</Typography>
                            <Typography sx={{ fontSize: '12px', fontWeight: '400', color: '#9095A1', fontFamily: 'Manrope' }}>This feature enables you to establish policies that automatically start and stop the desktop timer for your team.</Typography>
                        </Box>
                        <Button onClick={() => setOpenAutomaticTimer(true)} variant="contained" sx={{ boxShadow: 'none', fontFamily: 'Manrope', height: '38px', borderRadius: '100px', backgroundColor: '#0076FE', border: '1px solid #0076FE', color: '#fff', textTransform: 'capitalize' }} >
                            + Add Policy</Button>
                    </Box>
                </CustomTabPanel>
            </Box>
            <AutomaticTimer open={openAutomaticTimer} onClose={() => setOpenAutomaticTimer(false)} />
        </>
    )
}
const CustomTabPanel = ({ value, index, children }) => {
    if (value !== index) return null;
    return <Box sx={{ padding: { xl: '16px 5px', lg: '15px 0', md: '15px 0', sm: '15px  0', sx: '15px 0' } }}>{children}</Box>;
};


export default TimerTracking
